import { useState } from "react";
import { Button } from "../../../components/ui/button";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from "../../../components/ui/dialog";

import { Label } from "../../../components/ui/label";
import {
  Select,
  SelectContent,
  SelectGroup,
  SelectItem,
  SelectLabel,
  SelectTrigger,
  SelectValue,
} from "../../../components/ui/select";
import apiClient from "../../../utils/apiClient";
import server from "../../../utils/serverConfig";

export function EditRegimeModal({ fetchRegimeData }) {
  // 0 ---> b , 1 --> g , -1 --> r

  const signalData = [
    { value: "R000", title: "R000" },
    { value: "R001", title: "R001" },
    { value: "R010", title: "R010" },
    { value: "R011", title: "R011" },
    { value: "R100", title: "R100" },
    { value: "R101", title: "R101" },
    { value: "R110", title: "R110" },
    { value: "R111", title: "R111" },
    { value: "S000", title: "S000" },
    { value: "S001", title: "S001" },
    { value: "S010", title: "S010" },
    { value: "S011", title: "S011" },
    { value: "S100", title: "S100" },
    { value: "S101", title: "S101" },
    { value: "S110", title: "S110" },
    { value: "S111", title: "S111" },
    { value: "F000", title: "F000" },
    { value: "F001", title: "F001" },
    { value: "F010", title: "F010" },
    { value: "F011", title: "F011" },
    { value: "F100", title: "F100" },
    { value: "F101", title: "F101" },
    { value: "F110", title: "F110" },
    { value: "F111", title: "F111" },

  ];

  const [open, setOpen] = useState(false);
  const [niftyRegimeSignal, setNiftyRegimeSignal] = useState("");

  const handleEditRegimeSignal = () => {
    const data = {
      regime_signal_nifty: niftyRegimeSignal,
    };

    console.log("Updated Regime Signal", data);

    let config = {
        method: "post",
        url: `${server.godseye.baseUrl}edit/regime`,
        headers: {
            "Content-Type": "application/json",
        },
        data: JSON.stringify(data), // Convert the data object to a JSON string
    };

    apiClient
        .request(config)
        .then((response) => {
            console.log("Server response:", response.data);
            // Optionally handle the response data here
        })
        .catch((error) => {
            console.error("Failed to update Regime signal:", error);
            fetchRegimeData()
        })
        .finally(() => {
            setOpen(false); // Close the modal or perform any final actions
            fetchRegimeData()
        });
  };

  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogTrigger asChild>
        <Button
          varinat="outline"
          className="text-[16px] font-medium bg-zinc-800 text-white hover:bg-zinc-700"
        >
          Edit Regime Signal
        </Button>
      </DialogTrigger>
      <DialogContent className="sm:max-w-[525px] border-zinc-700">
        <DialogHeader>
          <DialogTitle className="text-white">
            Edit Regime Signal Values
          </DialogTitle>
        </DialogHeader>
        <div className="grid gap-4 py-4">
          <div className="grid grid-cols-1 items-center gap-4">
            <Label className=" text-white">Nifty</Label>
            <Select onValueChange={(value) => setNiftyRegimeSignal(value)}>
              <SelectTrigger className=" text-muted-foreground">
                <SelectValue placeholder="Select Regime Signal Nifty" />
              </SelectTrigger>
              <SelectContent className="border-zinc-700 max-h-[200px] overflow-y-auto">
                <SelectGroup>
                  <SelectLabel>Signal Values</SelectLabel>
                  {signalData.map((item) => (
                    <SelectItem key={item.value} value={item.value}>
                      {item.title}
                    </SelectItem>
                  ))}
                </SelectGroup>
              </SelectContent>
            </Select>
          </div>
          {/* <div className="grid grid-cols-1 items-center gap-4">
            <Label className=" text-white">BankNifty</Label>
            <Select onValueChange={(value) => setBankiftyVmaSignal(value)}>
              <SelectTrigger className=" text-muted-foreground">
                <SelectValue placeholder="Select VMA Signal BankNifty" />
              </SelectTrigger>
              <SelectContent className="border-zinc-700">
                <SelectGroup>
                  <SelectLabel>Signal Values</SelectLabel>
                  {signalData.map((item) => (
                    <SelectItem key={item.value} value={item.value}>
                      {item.title}
                    </SelectItem>
                  ))}
                </SelectGroup>
              </SelectContent>
            </Select>
          </div> */}
        </div>
        <DialogFooter>
          <Button
            type="submit"
            className="text-[16px] font-normal bg-zinc-800 text-white hover:bg-zinc-700"
            onClick={handleEditRegimeSignal}
          >
            Update Regime Signal
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
